import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

export default function useInstantPurchase(Products) {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const session = useSelector((state) => state.session);
  const hasDispatched = useRef(false);

  useEffect(() => {
    const instant = searchParams.get("instant");
    const plan = searchParams.get("plan");
    const PaymentMethod = searchParams.get("paymentMethod");

    if (instant !== "1" || !plan) return;
    if (hasDispatched.current) return;
    console.log("instant buy start");
  

    // ✅ Aguarda os produtos serem carregados
    if (!Products) return;
    console.log("instant buy Products", Products);
    const getPlanById = (id_product) => {
      return Products.periodicity.find(
        (item) => item.id_product === Number(id_product)
      );
    };


    const planInfo = getPlanById(plan);
    console.log("step 0: ", plan);
    console.log("step 0.1: ", planInfo);
    console.log("step 1: ", planInfo);
    console.log("step 2: ", !session.session?.sub);
    console.log("step 3: ", !session.session?.email);
    console.log("step session: ", session);
    if (!planInfo || !session.session?.sub || !session.session?.email) return;

    console.log("🚀 Disparando compra instantânea para o plano:", planInfo);

    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "PaymentArea",
        step: "InvoiceData",
      },
      PostData: {
        sub: session.session.sub,
        product_id: [Number(plan)],
        email: session.session.email,
        periodicity: planInfo.periodicity,
        payment_method: {type: PaymentMethod},
      },
      planInfo: {
        // payment_method: PaymentMethod,
        // paymentMethod: PaymentMethod,
        // pixPayment: true,
        lifetime: planInfo.lifetime,
        planName: planInfo.name,
        planDescription: planInfo.description.product_descriptions,
        periodicity: planInfo.periodicity,
        value: planInfo.price
          ? `R$ ${parseFloat(planInfo.price)
              .toFixed(2)
              .replace(".", ",")}`
          : "R$ 0,00",
      },
    });
    //  dispatch({
    //     type: "PURCHASE",
    //     purchase: {
    //       content: "PaymentArea",
    //       step: "PixQrCode",
    //     },      
    //   });

    hasDispatched.current = true;
  }, [searchParams, Products, session]);
}
